import { render } from "./list-reports-chart.vue?vue&type=template&id=0b9634d2&scoped=true&ts=true"
import script from "./list-reports-chart.vue?vue&type=script&lang=ts"
export * from "./list-reports-chart.vue?vue&type=script&lang=ts"

import "./list-reports-chart.vue?vue&type=style&index=0&id=0b9634d2&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b9634d2"]])

export default __exports__